import { render } from "./Doctor.vue?vue&type=template&id=ac1dccf4&scoped=true"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"

import "./Doctor.vue?vue&type=style&index=0&id=ac1dccf4&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1dccf4"]])

export default __exports__